<template>
    <vx-sticky-nav
        :sections="props.sections"
        class="vx-col-span-12 lg:vx-col-span-8 lg:vx-col-start-3"
        contentClasses="vx-flex vx-mx-auto vx-gap-2 md:vx-gap-8 vx-flex-col vx-w-full vx-max-w-screen-sm vx-items-stretch"
        :navClasses="props.hideNav ? 'vx-hidden' : ''"
    >
        <slot></slot>
    </vx-sticky-nav>
</template>

<script setup>

import { VxStickyNav } from '@voxie/frontend-components';

const props = defineProps({
    hideNav: Boolean,
    sections: Array,
})

</script>
